import useRequest from '../utils/useRequest'

// Calls the BFF (same origin as the SPA), which forwards the request to the IDP RSV API.
function useBffFlumeterMap(startDate, endDate, geoType) {
  const { data, error } = useRequest({
    baseURL: process.env.REACT_APP_BFF_BASE_URL || '',
    url: geoType==='activecbsa'? '/api/flumeter/activecbsa' : '/api/flumeter/map',
    method: geoType==='activecbsa'?'GET':'POST',
    headers: {
      'Content-Type': 'application/json',
      requester: JSON.stringify(window.localStorage.getItem('requester')),
    },
    data: { startDate, endDate, geoType },
    withCredentials: true,
  })

  return { data, error }
}

export default useBffFlumeterMap
